import React from 'react';
import Icons from '../../../../../components/Common/Icons/Icons';
import { statementsAccordion, statementsCol } from '../Data';
import StatementPageTemplate from '../StatementPageTemplate';
import { SEARCH_SUGGESTIONS } from '../../Notices/Data';

function CheckingStatements() {
  return (
    <StatementPageTemplate
      icon={<Icons.UserCheck />}
      title="Checking Statements"
      tableProps={{
        data: statementsAccordion,
        tableCol: statementsCol,
      }}
      searchSuggestions={SEARCH_SUGGESTIONS}
    />
  );
}

export default CheckingStatements;
